import { commentsItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            读者评论
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            来自每日大赛mrds社区创作者和用户的声音
          </p>

          <div className="space-y-4">
            {commentsItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5"
              >
                <div className="flex items-start gap-3">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-9 h-9 rounded-full object-cover flex-shrink-0"
                  />
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="font-heading font-semibold text-sm text-foreground-900">
                        {item.name}
                      </span>
                      <span className="text-xs text-foreground-400">{item.time}</span>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                      {item.content}
                    </p>
                    <div className="flex items-center gap-1 text-xs text-foreground-400">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-heart-line text-foreground-400"></i>
                      </div>
                      <span>{item.likes}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}